// @core/api/endpoints/knowledge/index_source.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  IndexSourceRequest,
  KnowledgeSourceResponse,
} from '../../../types/knowledge';

const BASE_PATH = '/knowledge';

/**
 * Index source
 * Attaches a source — a platform entity such as a document, or inline text — to a knowledge base and queues it for chunking and embedding. Returns the source in PENDING status; indexing completes asynchronously.
 */
export async function IndexSource(
  base_id: string,
  data: IndexSourceRequest,
  options?: RequestOptions
): Promise<KnowledgeSourceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id/sources`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.post<KnowledgeSourceResponse>(requestPath, data, requestOptions);
}
